import { Component, Vue } from 'vue-property-decorator';

@Component
export default class TimesheetValidator extends Vue {
  public errors = {
    selectedCompany: '',
    selectedJob: '',
    weekStart: '',
    totalSampleHours: '',
  };
  onAddHours(e) {
    const value = e.target.value + e.key;
    if ((value && value.length > 4) || value.match(/[0-9]*\.[0-9]{2}/g)) {
      e.preventDefault();
    }
    return true;
  }
  validateTimesheet({ selectedCompany, selectedJob, weekStart, selectedWeek }) {
    this.errors.selectedCompany = selectedCompany
      ? ''
      : this.$t('timesheet-client-name-is-required').toString();
    this.errors.selectedJob = selectedJob ? '' : this.$t('timesheet-job-name-is-required').toString();
    this.errors.weekStart = weekStart ? '' : this.$t('timesheet-start-date-is-required').toString();
    return (
      !Object.values(this.errors).find((error) => error !== '') &&
      !selectedWeek.find((day) => day.error)
    );
  }
  public resetErrors() {
    this.errors.selectedCompany = '';
    this.errors.selectedJob = '';
    this.errors.weekStart = '';
    this.errors.totalSampleHours = '';
  }
  public validateSampleHourField({ workedHours, offHours }) {
    if (workedHours + offHours > 24) {
      this.errors.totalSampleHours = this.$t('timesheet-hours-cannt-exceed-24hs').toString();
    } else {
      this.errors.totalSampleHours = '';
    }
  }
  public validateDayHourField({ selectedWeek }) {
    selectedWeek.forEach((day) => {
      if (day.workedHours + day.offHours > 24) {
        day.error = this.$t('timesheet-hours-cannt-exceed-24hs').toString();
      } else {
        day.error = '';
      }
    });
  }
}
